<script>
export default {
    name: "CancelledBillsReport",
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li>
                <router-link :to="{name : `reports.accounts-finance.index` }">Accounts & Finance Reports</router-link>
             </li>
             <li><span class="mx-2">/</span></li>
             <li>Cancelled patient bills</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Cancelled patient bills</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" id="grid-search" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-ward" class="label-control">Item:</label>
                  <tail-select>
                      <template v-slot:field>
                          <select id="grid-item" class="input-control input-sm text-xs">
                              <option value=""></option>
                          </select>
                      </template>
                  </tail-select>
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-user" class="label-control">User:</label>
                  <tail-select>
                      <template v-slot:field>
                          <select id="grid-user" class="input-control input-sm text-xs">
                              <option value=""></option>
                          </select>
                      </template>
                  </tail-select>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-3 text-center">
                  <button class="btn-sm btn-info text-xs rounded"><i class="fa fa-filter"></i> Filter</button>
              </div>
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/6">MRN</th>
                            <th class="p-tiny w-1/6">Patient</th>
                            <th class="p-tiny w-1/6">IPFile No</th>
                            <th class="p-tiny w-1/6">OPFile No</th>
                            <th class="p-tiny w-1/6">Requested By</th>
                            <th class="p-tiny w-1/6">Amount</th>
                        </tr>
                  </thead>
                  <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:65vh;">
                      <tr class="w-full flex">
                          <td class="p-tiny w-1/6"></td>
                          <td class="p-tiny w-1/6"></td>
                          <td class="p-tiny w-1/6"></td>
                          <td class="p-tiny w-1/6"></td>
                          <td class="p-tiny w-1/6"></td>
                          <td class="p-tiny w-1/6"></td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>